import React from 'react';
import { Coffee, Factory, Package, Shirt } from 'lucide-react';

const industries = [
  {
    title: 'Manufacturing',
    description:
      'Expert consultants for complex manufacturing processes, production planning, and supply chain optimization in M3.',
    icon: Factory,
    iconBackground: '#FFF1E8',
    accentColor: '#EA580C',
    borderColor: '#FED7AA',
  },
  {
    title: 'Fashion & Apparel',
    description:
      'Specialists in seasonal product lifecycles, variant management, and fashion-specific M3 modules.',
    icon: Shirt,
    iconBackground: '#FDF2F8',
    accentColor: '#DB2777',
    borderColor: '#FBCFE8',
  },
  {
    title: 'Food & Beverage',
    description:
      'Professionals experienced in perishable inventory management, compliance, and traceability requirements.',
    icon: Coffee,
    iconBackground: '#ECFDF5',
    accentColor: '#059669',
    borderColor: '#A7F3D0',
  },
  {
    title: 'Distribution',
    description:
      'Consultants skilled in warehouse management, logistics, and distribution-specific M3 functionalities.',
    icon: Package,
    iconBackground: '#F5F3FF',
    accentColor: '#7C3AED',
    borderColor: '#DDD6FE',
  },
];

const IndustryCard = ({
  title,
  description,
  icon: Icon,
  iconBackground,
  accentColor,
  borderColor,
}) => (
  <article
    className="group flex h-full min-w-0 flex-col rounded-2xl border bg-white p-6 transition duration-300 hover:-translate-y-1 hover:shadow-lg"
    style={{
      borderColor,
      boxShadow: '0 8px 24px rgba(15, 23, 42, 0.04)',
    }}
  >
    <div
      className="mb-5 flex h-12 w-12 items-center justify-center rounded-xl transition duration-300 group-hover:scale-105"
      style={{ backgroundColor: iconBackground, color: accentColor }}
    >
      <Icon aria-hidden="true" className="h-6 w-6" strokeWidth={1.8} />
    </div>

    <h3
      className="mb-3 text-lg font-bold leading-snug"
      style={{ color: '#1A2634' }}
    >
      {title}
    </h3>

    <p
      className="text-sm font-medium leading-6"
      style={{ color: '#334155', textAlign: 'left' }}
    >
      {description}
    </p>
  </article>
);

const M3Industries = () => {
  return (
    <section
      aria-labelledby="m3-industries-title"
      className="px-4 py-14 sm:px-6 lg:px-8 lg:py-20"
      style={{ backgroundColor: '#FFFFFF' }}
    >
      <div className="mx-auto w-full max-w-7xl">
        <h2
          id="m3-industries-title"
          className="mb-10 text-2xl font-bold tracking-tight sm:text-3xl md:text-4xl"
          style={{ color: '#1A2634' }}
        >
          Industries We Serve
        </h2>

        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {industries.map((industry) => (
            <IndustryCard key={industry.title} {...industry} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default M3Industries;
